import { Layout } from "Components/Layout/Layout";
import { LoadDetails } from 'Containers/Loads/LoadDetails/LoadDetails';

export const LoadDetailsPage = () => {
  return (
    <Layout>
      <LoadDetails />
    </Layout>
  );
};
